import React, { useEffect, useState } from 'react'
import parse, { HTMLReactParserOptions } from 'html-react-parser'
import { Block } from './components/Block'
import { ProductBlock } from './components/ProductBlock'
import { useCmsBlock } from 'lib/core/hooks'
import { useLocation } from 'react-router-dom'

interface Props {
  slug: string
}

const SidebarBlock = 'blog_sidebar'
export const SidebarBlocks = ({ slug }: Props) => {
  const { pathname } = useLocation()
  const parsedSlug = slug?.replace('-&-', '-')
  const [content, setContent] = useState<string | undefined>()
  const sidebarBlock = useCmsBlock({
    id: `blog_sidebar_product_${parsedSlug}`,
    isLazy: true
  })

  const generalBlogSidebarBlock = useCmsBlock({
    id: SidebarBlock,
    isLazy: false
  })

  useEffect(() => {
    if (!sidebarBlock.isFailure && !sidebarBlock.isLoading) {
      setContent(sidebarBlock.content)
      return
    }

    if (generalBlogSidebarBlock.content) {
      setContent(generalBlogSidebarBlock.content)
    }
    // eslint-disable-next-line
  }, [sidebarBlock.content, generalBlogSidebarBlock.content, pathname])

  if (!sidebarBlock.content && !generalBlogSidebarBlock.content) return null

  const parseOptions: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      switch (attribs.id) {
        case 'product':
          return <ProductBlock sku={children?.[0].data} />

        default:
          return <Block blockId={attribs.id} />
      }
    }
  }

  const contentParent = document.createElement('div')
  contentParent.innerHTML = content ?? ''
  const elements = contentParent.querySelectorAll('div')

  return (
    <div className='blocks'>
      {Boolean(elements.length) && (
        <>
          {Array.from(elements).map(el => parse(el.outerHTML, parseOptions))}
        </>
      )}
    </div>
  )
}
